'use client';

import React from 'react';
import { FiLoader } from 'react-icons/fi';

export default function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-slate-900">
      <div className="text-center">
        <FiLoader className="h-12 w-12 mx-auto text-blue-500 animate-spin" />
        <h2 className="mt-4 text-xl font-medium text-gray-900 dark:text-white">
          Loading...
        </h2>
        <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
          Please wait while we prepare your content.
        </p>
      </div>
    </div>
  );
}
